export const PATH = {
  HOME: '/',
  MAP: '/map',
};
